import { render, staticRenderFns } from "./StaffHandle.vue?vue&type=template&id=e41443b4&scoped=true"
import script from "./StaffHandle.vue?vue&type=script&lang=js"
export * from "./StaffHandle.vue?vue&type=script&lang=js"
import style0 from "./StaffHandle.vue?vue&type=style&index=0&id=e41443b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41443b4",
  null
  
)

export default component.exports